'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:SessionStorage
 * @description
 * # SessionStorage service, to mange the session storage
 * Service of the thothApp
 */
angular.module('thothApp.services')
  .factory('SessionStorage', ['$window', function ($window) {
    return {
      getFromSessionStorage: function(key) {
        if(key in $window.sessionStorage) {
          return JSON.parse($window.sessionStorage[key]);
        } else {
          return {};
        }
      },
      saveToSessionStorage: function(key, object) {
        $window.sessionStorage[key] = JSON.stringify(object);
      },
      existsInSessionStorage: function(key)
      {
        if(key in $window.sessionStorage)
        {
          return true;
        }
        return false;
      }
    };
  }]);
